import React from 'react'
import { Toolbar, AppBar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserProfileMenu } from '../../../../common-client2/src/components';
import './topBar.scss';

const topBar = (props) => {
    const isStatic = props.isStatic;
    const { t } = useTranslation('common');

    let name;
    let initials;
    let position = (isStatic) ? 'static' : 'fixed';

    if (props.person) {
        name = `${props.person.firstName} ${props.person.lastName}`;
        initials = `${props.person.firstName[0]}${props.person.lastName[0]}`;
    } else {
        name = sessionStorage.getItem('username');
        let initialsArray = name.split(' ');
        initials = initialsArray.map(word => word[0]);
    }

    return (
        <AppBar position={position} className="topbar-appbar">
            <Toolbar className="topbar-toolbar" >
                {props.children}
                <div className="topbar-user-tools">
                    {/* {
                        (i18n.language.includes('en')) ?
                            <Button color="inherit" onClick={() => changeLang("fr")}>FR</Button>
                            :
                            <Button color="inherit" onClick={() => changeLang("en")}>EN</Button>
                    } */}
                    <UserProfileMenu
                        initials={initials}
                        fullName={name}
                        version={props.buildInfos.version}
                        environement={t(`environment.${props.buildInfos.environment}`)}
                        labels={{
                            sectionTitleAbout: t(`userMenu.about`),
                            aboutVersion: t(`userMenu.version`),
                            aboutEnvironment: t(`userMenu.environment`)
                        }}
                    />
                </div>
            </Toolbar>
        </AppBar>
    )
}

export default topBar;